import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../../../core/custom-table";
import { HTTP_METHODS, invokeApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { Download } from "@mui/icons-material";
import { saveAs } from "file-saver";

const TrainingCertificateOem = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {date} =  location.state || {};
    const [certificateList, setCertificateList] = useState([]);

    const trainingCertificateListOem = {
        HeaderConfig: [
            {
              label: "S l No.",
              id: "serialNumber"
            },
            {
              label: "Name of the Candidate",
              id: "name"
            },
            {
              label: "Age",
              id: "age"
            },
            {
              label: "Qualification",
              id: "qualification"
            },
            {
              label: "No. of years of Experience",
              id: "experienceInYears"
            },
            {
              label: "Designation",
              id: "designation"
            },
            {
                label: "Download Certificate",
                id: "certificate",
                render: (data) => {
                    return( 
                         
                            <>   
                            <div className='download-icon'>
                              <Download size="small" onClick={()=>downloadCertificate(data)}/>    
                            </div>                         
                            </>
                    )
                }
            } 
          ]
    };

    const downloadCertificate = (data) => {
        data?.certificate && saveAs(data?.certificate, `${data.name}_certificate.pdf`);
    };

    useEffect(() => {
        getCertificateList()
    },[]);

    const transformedData = certificateList?.map(item => ({
        courseName: item.course,
        trainingMode: item.trainingMode,
        numberOfParticipants: item.numberOfParticipants,
        participants: item.participants,
        dealerName: item.dealerName,
        address: item.address,
        approvalBy: item.approvalBy,
        venue: item.venue
    }));

    const getCertificateList = () => { 
      setCertificateList([]);
        invokeApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.OEM_APPROVAL_STATUS}?status=COMPLETED`,
            null
          ).then((response) => {
            if (response) {
              const candidateListTableData = response[0]?.participants?.length ? response[0].participants.map((listItem,index) => {
                 return (
                     {
                        serialNumber: index+1,
                        name:listItem.name,
                        age: listItem?.age,
                        qualification: listItem?.qualification,
                        experienceInYears: listItem?.experienceInYears,
                        designation: listItem?.designation,
                        certificate: listItem.certificate
                     }
                 )
             }) : [];
             setCertificateList([...candidateListTableData])
            }
          });

    };

 
    
    return (
        <>
             <div className="training-request-list-container">
                <div className="title-container">
                    <span className="training-title">Training</span> 
                    <div className="list-title">Certificate</div>
                </div>               
                <div className="list-container">
                <CustomTable
                    header={trainingCertificateListOem.HeaderConfig}
                    data={certificateList || []}
                    //pageCount={pastTickets.totalPages}
                    //onClick={onRowClick}
                    //filters={filters}
                    /* onChange={(page) => {
                        setFilters({
                        ...filters,
                        page,
                        }); */
                        /* loadData({
                        ...filters,
                        page,
                        }); */
                    //}}
                    />
                </div>
            </div>
        </>
    )
};

export default TrainingCertificateOem;